function ErrorComponent() {
  return <div>Unable to load users</div>;
}

export default ErrorComponent;
